import { useLocation } from "react-router-dom"

import { PRODUCT_CONFIGURATION } from "shared/constants/permalinks"

export function useIsProductConfigurationPage() {
  const { pathname } = useLocation()
  return pathname.includes(`/${PRODUCT_CONFIGURATION}/`)
}
